export const marquee = () => {
    document.querySelectorAll('span').forEach(el => {
        replaceTag(el, 'marquee');
    });
};
const replaceTag = (originalElement, newTag) => {
    const newElement = document.createElement(newTag);
    Array.from(originalElement.childNodes).map(child => newElement.appendChild(child));
    Array.from(originalElement.attributes).map(attr => newElement.setAttribute(attr.name, attr.value));
    originalElement.parentNode?.replaceChild(newElement, originalElement);
};
//# sourceMappingURL=fun.js.map